/**
 * @voltxampere/ui — TIP120 NPN Darlington pair variant (Sprint 44-2)
 *
 * Reference: TI TIP120 datasheet — TO-220 NPN Darlington pair.
 *   V_CEO = 60 V          (collector-emitter breakdown)
 *   I_C = 5 A             (continuous collector current)
 *   β = 1000              (DC current gain — Darlington pair multiplied)
 *   V_BE(on) = 2.5 V      (base-emitter saturation, two junctions)
 *   V_CE(sat) = 2.0 V     (collector-emitter saturation)
 *   Is ≈ 1e-12 A          (placeholder — Darlington internal Is)
 *   Vaf = 80 V            (forward Early voltage)
 *
 * PLACEHOLDER NOTE: Darlington pair internal structure (two BJTs
 * cascaded) modellenmemiş. Gerçek Darlington davranışı Sprint 50+
 * "Darlington pair" composite type ile aktif olur. Şu anki stamp
 * tek BJT NPN olarak davranır (β = 1000 elevated meta).
 *
 * Engine zero-diff invariant honored — canonical `bjt-npn` engine
 * type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { npn } from "../npn.js";
export const powerBjtTip120 = {
    id: "tip120",
    nameTr: "TIP120 (NPN Darlington, 60V/5A, TO-220)",
    nameEn: "TIP120 (NPN Darlington, 60V/5A, TO-220)",
    shortcut: "Q",
    category: "active",
    viewBox: npn.viewBox,
    terminals: npn.terminals,
    defaultLabel: "Q",
    defaultValue: "TIP120",
    schemaType: "bjt-npn",
    defaultParams: { Is: 1e-12, Bf: 1000, Vaf: 80 },
    renderSVG: () => npn.renderSVG(),
};
//# sourceMappingURL=power-bjt-tip120.js.map